export function normalizeDescription(description) {
  return String(description || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Build dedup lookup keys from existing transactions for an account.
 * @param {object[]} existingTransactions
 * @returns {{ fitIds: Set<string>, fallbacks: Set<string> }}
 */
export function buildDedupIndex(existingTransactions) {
  const fitIds = new Set();
  const fallbacks = new Set();

  for (const tx of existingTransactions) {
    if (tx.ofxFitId) {
      fitIds.add(tx.ofxFitId);
      continue;
    }
    fallbacks.add(buildFallbackKey(tx));
  }

  return { fitIds, fallbacks };
}

export function buildFallbackKey(tx) {
  const date = Number(tx.date) || 0;
  const amount = Math.round((Number(tx.amount) || 0) * 100) / 100;
  const desc = normalizeDescription(tx.description);
  return `${date}|${amount}|${desc}`;
}

/**
 * Classify parsed OFX rows as import or skip.
 * @param {object[]} parsedRows
 * @param {object[]} existingTransactions - same account only
 * @returns {{ toImport: object[], toSkip: object[] }}
 */
export function classifyOfxImport(parsedRows, existingTransactions) {
  const { fitIds, fallbacks } = buildDedupIndex(existingTransactions);
  const toImport = [];
  const toSkip = [];

  for (const row of parsedRows) {
    if (row.ofxFitId && fitIds.has(row.ofxFitId)) {
      toSkip.push({ ...row, skipReason: 'Duplicata (FITID)' });
      continue;
    }

    const fallbackKey = buildFallbackKey(row);
    if (!row.ofxFitId && fallbacks.has(fallbackKey)) {
      toSkip.push({ ...row, skipReason: 'Possível duplicata' });
      continue;
    }

    toImport.push(row);
    if (row.ofxFitId) {
      fitIds.add(row.ofxFitId);
    } else {
      fallbacks.add(fallbackKey);
    }
  }

  return { toImport, toSkip };
}
